
    const original = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\"><path fill=\"#855cd6\" fill-rule=\"evenodd\" d=\"M12.63 12.637a.886.886 0 0 1-.755-1.333 2.569 2.569 0 0 0 0-2.6.888.888 0 0 1 .31-1.213.878.878 0 0 1 1.204.311 4.346 4.346 0 0 1 0 4.401.875.875 0 0 1-.758.434zm2.627 1.418a.886.886 0 0 1-.755-1.333 5.367 5.367 0 0 0 0-5.437.888.888 0 0 1 .309-1.212.88.88 0 0 1 1.204.31 7.138 7.138 0 0 1 0 7.238.877.877 0 0 1-.758.434zM10.379 5.68v8.641c0 1.024-1.207 1.56-1.96.87l-1.624-1.492a3.112 3.112 0 0 0-2.104-.82h-.284A1.41 1.41 0 0 1 3 11.464V8.55c0-.781.63-1.414 1.407-1.414h.268c.78 0 1.529-.293 2.104-.82L8.42 4.81c.753-.69 1.96-.154 1.96.869Z\"/></svg>";

    const getSRC = () => {
        const recolored = typeof Recolor === 'object' ? (
            original.replace(/#855cd6/gi, Recolor.primary)
        ) : original;
        return 'data:image/svg+xml;,' + encodeURIComponent(recolored);
    };

    export default getSRC;
